import { getRegion, getLocale, getCaid, getDomain, getConfigurationObject } from "@/data/regionInfo";

export default ({ $store }) => {
  return {
    install(Vue) {
      Vue.prototype.$endpoints = {
        /**
         * @function setEndpointEnv
         * @param {String} type
         * Replaces {ENV} to external environment defined by type argument
         */
        setEndpointEnv(type = null, isMainApp) {
          if (!type) {
            console.error('aborting $endpoints.setEndpointEnv, type must be defined');
            return;
          }

          const { VUE_APP_ENDPOINTS, VUE_APP_ENV } = process.env;
          const { endPoints } = $store.state;
          const vuecomponentsData = document.getElementById('vfdp-vuecomponents-data');
          let env = VUE_APP_ENV && VUE_APP_ENV !== '{ENV}' ? VUE_APP_ENV : 'dev';
          let data = null;
          if (vuecomponentsData) {
            data = vuecomponentsData.dataset && vuecomponentsData.dataset.vuecomponentsObject;
          }

          if (data) {
            data = JSON.parse(data);

            if (data && data.env) {
              env = data.env;
            }
          }

          const queryParams = $store.state.utils.queryParams;
          if (queryParams && queryParams.env) {
            env = queryParams.env
          };

          $store.commit('utils/SET_ENV', env);
          $store.commit('endPoints/SET_ENDPOINTS', {
            endpoints: {
              endpoints: VUE_APP_ENDPOINTS.replace(/\{ENV\}/g, env)
            },
            type
          });
          if (isMainApp) {
            this.setCaidConfiguration(type);
          }
        },
        setCaidConfiguration(type) {
          if (this.isCaidConfiguratorLoaded) {
            return;
          }

          this.isCaidConfiguratorLoaded = true;

          $store.dispatch('utils/GET_CONFIGURATION', type)
            .then(configuration => {
              this.isConfiguratorLoaded = true;
            }).then(()=> {
              if ($store.state.utils.queryParams.canvas) $store.dispatch("utils/FETCH_HEADERS_DATA");
            });
        },
        /**
         * @function setConfigurationEnv
         * @param none
         * Sets domain, region, locale and vfdp-vuecomponents-data if exists in utils.configuration vuex attribute
         */
        setConfigurationEnv() {
          if (this.isConfigurationEnvSet) {
            return;
          }

          this.isConfigurationEnvSet = true;

          const queryParams = $store.state.utils.queryParams;
          const configObject = getConfigurationObject() || {};
          const caid  = getCaid() ? getCaid().caid : "";
          let domain = (configObject && !configObject.domain) ? `https://${getDomain()}` : configObject.domain || process.env.VUE_APP_DOMAIN;
          if (queryParams && queryParams.domainName) {
            domain = queryParams.domainName
          };
          $store.commit('utils/SET_CONFIGURATION', { ...configObject, domain, region: getRegion(), locale: getLocale() });
          $store.commit('utils/SET_CAID', caid);
        },
        isConfigurationEnvSet: false,
        isCaidConfiguratorLoaded: false
      };

    }
  };
};
